module.exports = __webpack_public_path__ + "img/play-button.6863dd27.png";